import { getPopularDestinations } from './action';

export { popularDestinationsReducer } from './reducer';
export { watchPopularDestinations } from './saga';
export { GET_POPULAR_DESTINATIONS, GET_POPULAR_DESTINATIONS_SUCCESS } from './types';

export const popularDestinationsAction = {
  getPopularDestinations,
};
